import { Component, OnInit, Inject, AfterViewChecked, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { VariableValueBrowser } from 'src/app/setting/task/scheduler/variable/value.browser';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-service-task-config-variable-dialog',
	templateUrl: 'task.config.variable.dialog.html',
	styleUrls: ['./task.config.variable.dialog.scss']
})
// tslint:disable-next-line: component-class-suffix
export class TaskConfigVariableDialog implements OnInit, AfterViewChecked {

	selectTitle: string;

	task: any;
	step = 0;
	apiNames = environment.content.apiNames;

	@ViewChild('varForm', {static: true}) private varForm: NgForm;
	
	constructor(
		private dialog: MatDialog,
		private translateService: TranslateService,
		private dialogRef: MatDialogRef<TaskConfigVariableDialog>,
		@Inject(MAT_DIALOG_DATA) _data: any
	) {
		this.task = _data;
		this.step = 0;
	}

	showInvalid() {
		this.translateService.get('common.invalid.alert').subscribe((message: string) => {
			if (this.varForm.controls) {
				for (const control in this.varForm.controls) {
					this.varForm.controls[control].markAsTouched();
				}
			}	
			alert(message);
		});
	}

	getVariableState(step: number, indexOfVariable: number, variable: any) {
		return ((step < indexOfVariable) && (variable.variableValue === null || typeof variable.variableValue === 'undefined'));
	}

	setStep(index: number) {
		this.step = index;
	}

	nextStep(variable: any, indexOfVariable: number) {
		if (variable.variableValue === null || typeof variable.variableValue === 'undefined') {
			this.translateService.get('service.scheduler.task.dialog.config.alert.missing-value').subscribe((message: string) => {
				alert(message);
			});
			return;
		} else if (!this.varForm.controls['variableText' + indexOfVariable].valid) {
			this.translateService.get('common.invalid.alert').subscribe((message: string) => {
				this.varForm.controls['variableText' + indexOfVariable].markAsTouched();
				alert(message);
			});
			return;
		}
		this.step ++;
	}

	prevStep() {
		this.step --;
	}
  
	ngOnInit() {
		this.translateService.get('service.scheduler.task.dialog.config.content.select').subscribe((message: string) => {
			this.selectTitle = message;
		});
	}

	ngAfterViewChecked() {
	}

	doSelectValue(variable: any) {
		if (!variable.variable.apiColumns || variable.variable.apiColumns.columns.length == 0) {
			this.translateService.get('service.scheduler.task.dialog.config.alert.missing-api-columns').subscribe((message: string) => {
				alert(message);
			});
			return;
		}
		if (variable.variable.associates && variable.variable.associates.length > 0) {
			for (const associate of variable.variable.associates) {
				for (const configVariable of this.task.variables) {
					if (configVariable.variableName === associate.variableName) {
						if (!configVariable.variableValue) {
							this.translateService.get('service.scheduler.task.dialog.config.alert.missing-variable', {
								name: configVariable.name,
								looking: associate.name
							}).subscribe((message: string) => {
								alert(message);
							})
							return;
						} else {
							associate.variableValue = configVariable.variableValue;
							associate.variableText = configVariable.variableText;
						}
					}
				}
			}
		}

		const browser = new VariableValueBrowser(this.dialog, this.apiNames);

		browser.browse(variable.variable, variable.variableValue).subscribe(returnValue => {
			if (returnValue.result === true) {
				const variableValue = browser.getValue(variable.variable, returnValue.data);
    
				variable.variableValue = variableValue;
				if (browser.textColumn != null) {
				  variable.variableText = browser.getText(variable.variable, returnValue.data);
				} else {
				  variable.variableText = variable.variableValue;
				}
			}
		});  
	}

	getVariableText(templateVariableId: number) {
		if (this.task && this.task.variables) {
			for (const configVariable of this.task.variables) {
				if (configVariable.variableId === templateVariableId) {
					return configVariable.variableText;
				}
			}
		}
		return null;
	}

	onOk(): void {
		if (!this.varForm.valid) {
			this.showInvalid();
			return;
		} else {
			this.dialogRef.close({
				result: true,
				task: this.task
			});	
		}
	}

	onClose(): void {
		this.dialogRef.close({
			result: false
		});
	}

}

